// extracted by mini-css-extract-plugin
export default {"album":"Album_album__Vurwn"};